// extracted by mini-css-extract-plugin
module.exports = {"anchor--outline-teal":"Anchor_anchor--outline-teal__1Go9D","anchor--solid-volcano":"Anchor_anchor--solid-volcano__UdSVY","anchor--solid-teal":"Anchor_anchor--solid-teal__1dlpJ"};